export {
    IOperatorDetailsNotificationsPage,
    OperatorDetailsNotificationsPageInitializedArgs,
    OperatorDetailsNotificationsPageSubmitArgs,
    OperatorDetailsNotificationsPageOptions,
} from './operator-details.notifications.page.interfaces'
export { COMPONENT_NAME, OperatorDetailsNotificationsPageComponent } from './operator-details.notifications.page.component'